import { node, string } from 'prop-types';
import React from 'react';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';

import ChannelBox from '../../../ChannelBox';

function ChannelWithId({ channel, children }) {
  return (
    <Stack direction="row" alignItems="center" spacing={0.5}>
      <ChannelBox channel={channel} />
      <Typography fontWeight="fontWeightBold" variant="subtitle1" sx={{ color: 'black' }}>
        {children}
      </Typography>
    </Stack>
  );
}

ChannelWithId.propTypes = {
  channel: string.isRequired,
  children: node.isRequired
};

export default ChannelWithId;
